var map = {
	"./dev-group-tint.jpg": 381,
	"./dev-group.jpg": 382,
	"./diversity_staff_millennial.jpg": 196,
	"./faces/dark-hair-young-woman.jpg": 197,
	"./faces/young-man.jpg": 383,
	"./faces/young-woman.jpg": 132,
	"./group-meeting.jpg": 198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 380;